import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  addServantListener,
  addServantRankListener,
  addRankListener,
} from './reducers/servants/actions'
import ServantsPage from './components/ServantsPage'
import './App.css'

class App extends Component {
  componentDidMount () {
    this.props.addRankListener()
    this.props.addServantListener()
    this.props.addServantRankListener()
  }

  render () {
    return (
      <div className="App">
        <ServantsPage />
      </div>
    )
  }
}

export default connect(null, {
  addRankListener,
  addServantListener,
  addServantRankListener,
})(App)



// WEBPACK FOOTER //
// ./src/App.js